import { Component } from 'react';
import ReviewsController from './reviews.controller';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import Page from '../common/page/Page';
import FeedbackSummary from './elements/FeedbackSummary';
import RecentComments from './elements/RecentComments';
import { DEFAULT_FILTERS, DEFAULT_PAGE_SIZE, TIME_FRAME_OPTIONS } from './reviews.constants';
import { SCOPES } from '../../constants/scopes.constants';
import styles from './styles/reviews.module.scss';
import feedbackStyles from './styles/feedback.module.scss';
import PeriodControls from '../common/PeriodControls';

class Reviews extends Inherit(ReviewsController, Component) {
    state = {
        reviews: [],
        summary: {},
        loadingKPIs: true,
        loadingTable: true,
        filters: { ...DEFAULT_FILTERS },
        pageInfo: { current: 1, perPage: DEFAULT_PAGE_SIZE, total: 0 },
        dateRange: null,
    };

    render() {
        const {
            reviews,
            summary,
            loadingKPIs,
            loadingTable,
            filters,
            pageInfo,
            dateRange,
        } = this.state;

        return (
            <Page
                role="user"
                scope={SCOPES.REVIEWS_VIEW}
                title={{
                    text: 'User',
                    highlight: 'Feedback'
                }}
                description="View user feedback."
            >
                <PeriodControls
                    timeFrame={filters.timeFrame || '30d'}
                    dateRange={dateRange}
                    onTimeFrameChange={this.handleTimeFrameChange.bind(this)}
                    onDateRangeChange={this.handleDateRangeChange.bind(this)}
                    options={TIME_FRAME_OPTIONS}
                    showLabel={true}
                    containerClassName={styles.periodControls}
                    labelClassName={styles.periodLabel}
                />
                <div className={feedbackStyles.layout}>
                    <FeedbackSummary summary={summary} loading={loadingKPIs} />
                    <RecentComments
                        items={reviews}
                        loading={loadingTable}
                        pageInfo={pageInfo}
                        onPageChange={(page, perPage) => this.loadList(page, perPage)}
                    />
                </div>
        </Page>
        );
    }
}

export default withHooks(Reviews);
